import { render } from "./PoolStandingCard.vue?vue&type=template&id=04f71588&scoped=true"
import script from "./PoolStandingCard.vue?vue&type=script&lang=js"
export * from "./PoolStandingCard.vue?vue&type=script&lang=js"

import "./PoolStandingCard.vue?vue&type=style&index=0&id=04f71588&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f71588"]])

export default __exports__